export const environment = {
  production: true,
  SERVER_URL:'https://www.northbloomfield.com:3000/',// 'https://northbloomfield.com:3000/',//https://nbf.onlineprojectdemo.net:3000/
  RECAPTCHA_V3_SITE_KEY:'6LdSgYUgAAAAAEy46UXuGEcToCCsYfuLaiwH6dH3',
  // RECAPTCHA_V3_SITE_KEY:'6LedfvgcAAAAAL0PmDgpR-CQ7AulsrwbQCyqrjof',//demo sever
  MAP_ACCESS_KEY:'AIzaSyBsBSF1iikmML9mB48YU98Y4IcOYmA-ObI',
  BUCKET:'northbloomfield'
};
